export enum TaskStatus {
  PENDING = "PENDING",                  // ממתין לביצוע
  IN_PROGRESS = "IN_PROGRESS",          // בתהליך
  REQUEST_SENT = "REQUEST_SENT",        // בקשה נשלחה
  WAITING_FOR_CLIENT = "WAITING_FOR_CLIENT", // ממתין לתגובה מהלקוח
  COMPLETED = "COMPLETED",              // הושלם בהצלחה
  FAILED = "FAILED",                    // נכשל
  FILE_SAVED = "FILE_SAVED",             // קובץ נשמר, טרם עובד
  PERMANENT_FAILURE = "PERMANENT_FAILURE", // כשל קבוע
  CANCELLED = "CANCELLED",              // בוטל
  IDLE = "IDLE"                         // במצב סרק
}

export enum PreAdviceTaskType {
  PRE_ADVICE_FORM_SIGNING = "PRE_ADVICE_FORM_SIGNING",
  PRE_ADVICE_MISLAKA = "PRE_ADVICE_MISLAKA",
  PRE_ADVICE_FORM_AND_MISLAKA = "PRE_ADVICE_FORM_AND_MISLAKA",
  HAR_BITUACH_DOCUMENTS = "HAR_BITUACH_DOCUMENTS",
  HAR_BITUACH_FORM_SIGNING = "HAR_BITUACH_FORM_SIGNING",
  HAR_BITUACH_FORM_AND_DOCUMENTS = "HAR_BITUACH_FORM_AND_DOCUMENTS",
  POWER_OF_ATTORNEY = "POWER_OF_ATTORNEY"
}

export interface PreadviceTask {
    id?: number; // מזהה המשימה
    user_id: number; // מזהה המשתמש
    contact_id?: number; // מזהה איש הקשר
    lead_id?: number; // מזהה ליד
    deal_id?: number; // מזהה עסקה
    external_id: string; // מזהה חיצוני
    status: TaskStatus; // סטטוס המשימה
    task_type: PreAdviceTaskType; // סוג המשימה
    created_at?: string; // תאריך יצירה
    updated_at?: string; // תאריך עדכון
    fail_reason?: string; // סיבת כישלון
    file_path?: string; // נתיב לקובץ
  }
  